import { replace } from 'lodash';

import {
    COOKIE_KEY_ACCESS,
    COOKIE_KEY_DOMAIN,
    COOKIE_KEY_ID,
    COOKIE_KEY_SSO_JWT,
    COOKIE_KEY_SSO_SESSION,
    COOKIE_KEY_SSO_SSCK,
    COOKIE_KEY_USERNAME
} from '../../../constants/cookie';
import { DOMAIN_COOKIE, IS_DEV } from '../../../constants';
import { REQUEST_LOGOUT, SUCCESS_LOGOUT } from './constants';

import { resetInfos } from '../../account/actions';
import { forceFetchPartners } from '../../partner/actions';

import { makeActionCreator } from '../../../utils/actionsUtils';

export function logoutUser(callback) {
    return dispatch => {
        dispatch(requestLogout());
        dispatch(successLogout());
        deleteCookies();
        dispatch(resetInfos());
        dispatch(forceFetchPartners());
        if (callback) {
            callback();
        }
    };
}

const requestLogout = makeActionCreator(REQUEST_LOGOUT);
const successLogout = makeActionCreator(SUCCESS_LOGOUT);

const getCookieDomain = () => {
    return IS_DEV ? replace(DOMAIN_COOKIE, ':3000', '') : DOMAIN_COOKIE;
};

const deleteCookie = (name, domain) => {
    const cookieDomain = domain ? domain : getCookieDomain();
    document.cookie =
        name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + cookieDomain;
};

function deleteCookies() {
    deleteCookie(COOKIE_KEY_USERNAME);
    deleteCookie(COOKIE_KEY_ACCESS);
    deleteCookie(COOKIE_KEY_ID);
    deleteCookie(COOKIE_KEY_SSO_JWT, COOKIE_KEY_DOMAIN);
    deleteCookie(COOKIE_KEY_SSO_SSCK, COOKIE_KEY_DOMAIN);
    deleteCookie(COOKIE_KEY_SSO_SESSION, COOKIE_KEY_DOMAIN);
}



// WEBPACK FOOTER //
// ./src/services/authentication/logout/actions.js